import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AppEvents } from 'src/constants'

export const useCopy = (text: string | undefined | void | null) => {
  const [t] = useTranslation()
  const [isCopied, setIsCopied] = useState(false)

  return () => {
    if (!text) return

    const detail = {
      message: isCopied
        ? t('clipboard-already-copied-notification.v')
        : t('clipboard-copied-notification.v'),
    }
    const event = new CustomEvent(AppEvents.HTTP_SUCCESS, { detail })
    document.dispatchEvent(event)

    if (!isCopied) {
      setIsCopied(true)
      navigator.clipboard.writeText(text)
    }
  }
}
